/**
 * @generated SignedSource<<6c8b17a29b7c67d44163a267a173136f>>
 * @relayHash 0768561ad5ad2cd14f1e94bf09db8f45
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0768561ad5ad2cd14f1e94bf09db8f45

import { ConcreteRequest } from 'relay-runtime';
export type ChatTemplateType = "ADMINISTRATIVE" | "MEDICAL";
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type fetchChatTemplatesQuery$variables = {
  country: Country;
};
export type fetchChatTemplatesQuery$data = {
  readonly activeChatTemplates: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly chatTemplateTypes: ReadonlyArray<ChatTemplateType>;
        readonly languages: ReadonlyArray<{
          readonly content: string | null;
          readonly language: Language;
          readonly synonym: string | null;
          readonly title: string;
        }>;
        readonly name: string;
      };
    }> | null;
  } | null;
};
export type fetchChatTemplatesQuery = {
  response: fetchChatTemplatesQuery$data;
  variables: fetchChatTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "country"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "country",
    "variableName": "country"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chatTemplateTypes",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatTemplateLanguage",
  "kind": "LinkedField",
  "name": "languages",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "synonym",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchChatTemplatesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ActiveChatTemplatesConnection",
        "kind": "LinkedField",
        "name": "activeChatTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ActiveChatTemplatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "fetchChatTemplatesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ActiveChatTemplatesConnection",
        "kind": "LinkedField",
        "name": "activeChatTemplates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ActiveChatTemplatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0768561ad5ad2cd14f1e94bf09db8f45",
    "metadata": {},
    "name": "fetchChatTemplatesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3eef38fca4d1afad01c532f557d2920d";

export default node;
